import { useTranslation } from 'react-i18next';
import * as moment from 'moment';

/**
 * Hook centralizado de formatação de data/hora.
 *
 * Retorna strings de formato compatíveis com moment.js e a prop `ampm`
 * para os pickers do Material-UI, tudo baseado no idioma corrente do i18n.
 *
 * Uso:
 *   const { dateFormat, timeFormat, dateTimeFormat, ampm, formatDate, formatTime, formatDateTime } = useDateFormat();
 *
 *   // Exibir data:      formatDate(value)        → ex: "04/15/2026" (en) ou "15/04/2026" (pt)
 *   // Exibir hora:      formatTime(value)        → ex: "2:30 PM"   (en) ou "14:30"      (pt)
 *   // Exibir data+hora: formatDateTime(value)    → ex: "04/15/2026 2:30 PM" (en)
 *
 *   // Picker:
 *   <KeyboardDatePicker format={dateFormat} ampm={ampm} />
 *   <KeyboardTimePicker format={timeFormat} ampm={ampm} />
 */
export function useDateFormat() {
  const { t } = useTranslation();

  const dateFormat     = t('date-format');
  const timeFormat     = t('time-format');
  const dateTimeFormat = t('datetime-format');
  const ampm           = t('date-ampm') === 'true';

  const formatDate     = (value) => moment(value).format(dateFormat);
  const formatTime     = (value) => moment(value).format(timeFormat);
  const formatDateTime = (value) => moment(value).format(dateTimeFormat);

  return { dateFormat, timeFormat, dateTimeFormat, ampm, formatDate, formatTime, formatDateTime };
}
